import React, { useState, useEffect, useRef, useCallback } from "react";
import ReactDOM from "react-dom";
import logoMascota from "../../../../assets/logo-mascota.png";

const FRUTAS = ["🍎", "🍌", "🍓", "🍇", "🍊", "🥑", "🍍", "🍉"];
const OBSTACULOS_SUELO = ["🛒", "📦", "🪵", "🦛", "🐊", "🐀"]; 
const OBSTACULOS_AEREOS = ["🐉", "💰", "🏮"];

const PASILLOS = [
  { id: 0, nombre: "Pasillo de Frutas", bg: "from-emerald-600 via-green-700 to-teal-950", piso: "bg-emerald-950", borde: "border-emerald-800", patronFondo: "radial-gradient(circle, rgba(255,255,255,0.2) 15%, transparent 15%)", iconoFondo: "🍃" },
  { id: 1, nombre: "Pasillo de Lácteos", bg: "from-blue-600 via-indigo-800 to-slate-950", piso: "bg-blue-950", borde: "border-blue-800", patronFondo: "linear-gradient(90deg, rgba(255,255,255,0.12) 50%, transparent 50%)", iconoFondo: "💧" },
  { id: 2, nombre: "Pasillo de Panadería", bg: "from-amber-600 via-orange-800 to-stone-950", piso: "bg-amber-950", borde: "border-amber-800", patronFondo: "repeating-linear-gradient(45deg, rgba(0,0,0,0.25) 0, rgba(0,0,0,0.25) 15px, transparent 0, transparent 30px)", iconoFondo: "🌾" }
];

export default function RunnerSurtidor({ alCerrar }) {
  const [juegoAbierto, setJuegoAbierto] = useState(alCerrar ? true : false);
  const [jugando, setJugando] = useState(false);
  const [pausado, setPausado] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [puntuacion, setPuntuacion] = useState(0);
  const [record, setRecord] = useState(0);
  
  const [multiplicadorVisual, setMultiplicadorVisual] = useState(1);
  const [estrellasPartida, setEstrellasPartida] = useState(0);
  const [flashVisual, setFlashVisual] = useState(false);

  const [rankingBD, setRankingBD] = useState([]);
  const [miRecordMaximo, setMiRecordMaximo] = useState(0);
  const [misEstrellasMaximas, setMisEstrellasMaximas] = useState(0);

  const usuarioLocal = JSON.parse(localStorage.getItem("usuario") || "{}");
  const nombreUsuario = usuarioLocal.nombres || usuarioLocal.correo || "Tú";
  const centroTrabajoUsuario = usuarioLocal.centroTrabajo || usuarioLocal.cargo || "Actual";

  const MASCOTA_X = 60;
  const MASCOTA_SIZE = 58; 
  const ITEM_SIZE = 38;
  const ESTRELLA_SIZE = 38;
  const OBSTACULO_SIZE = 42;

  const mascotaY = useRef(0);
  const mascotaVy = useRef(0);
  
  const obstaculoX = useRef(900);
  const esAereo = useRef(false);
  const primerObstaculoPasado = useRef(false);
  
  const itemX = useRef(1300);
  const itemY = useRef(75);
  
  const estrellaX = useRef(2500);
  const estrellaY = useRef(115);
  const estrellaActiva = useRef(false);

  const velocidadGlobal = useRef(7.0);
  const puntajeRef = useRef(0);
  const multRef = useRef(1);
  const frutasComidasRef = useRef(0);
  const estrellasRef = useRef(0);

  const pasoAnim = useRef(0);
  const fondoX = useRef(0);
  const nubesX = useRef(0);
  const sueloX = useRef(0);
  const saltandoRef = useRef(false);

  const renderScaleY = useRef(1);
  const renderScaleX = useRef(1);
  const renderRot = useRef(0);

  const requestRef = useRef();
  const lastTimeRef = useRef(0);

  const mascotaRef = useRef(null);
  const obstaculoRef = useRef(null);
  const itemRef = useRef(null);
  const estrellaRef = useRef(null);
  const sueloRef = useRef(null);
  const fondoRef = useRef(null);
  const nubesRef = useRef(null);
  const obstaculoLabelRef = useRef(null);
  const itemLabelRef = useRef(null); 

  // 🎵 SINTETIZADOR DE EFECTOS DE SONIDO (WEB AUDIO API)
  const reproducirSonido = useCallback((tipo) => {
    try {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      if (!AudioContext) return;
      const ctx = new AudioContext();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();

      if (tipo === "salto") {
        osc.type = "sine";
        osc.frequency.setValueAtTime(300, ctx.currentTime);
        osc.frequency.exponentialRampToValueAtTime(600, ctx.currentTime + 0.15);
        gain.gain.setValueAtTime(0.2, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.15);
        osc.start(); osc.stop(ctx.currentTime + 0.15);
      } else if (tipo === "estrella") {
        osc.type = "triangle";
        osc.frequency.setValueAtTime(587.33, ctx.currentTime);
        osc.frequency.setValueAtTime(880, ctx.currentTime + 0.08);
        osc.frequency.setValueAtTime(1174.66, ctx.currentTime + 0.16);
        gain.gain.setValueAtTime(0.3, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.4);
        osc.start(); osc.stop(ctx.currentTime + 0.4);
      } else if (tipo === "fruta") {
        osc.type = "square";
        osc.frequency.setValueAtTime(450, ctx.currentTime);
        osc.frequency.exponentialRampToValueAtTime(800, ctx.currentTime + 0.1);
        gain.gain.setValueAtTime(0.15, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.1);
        osc.start(); osc.stop(ctx.currentTime + 0.1);
      } else if (tipo === "choque") {
        osc.type = "sawtooth";
        osc.frequency.setValueAtTime(150, ctx.currentTime);
        osc.frequency.linearRampToValueAtTime(40, ctx.currentTime + 0.3);
        gain.gain.setValueAtTime(0.4, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.3);
        osc.start(); osc.stop(ctx.currentTime + 0.3);
      }
      osc.connect(gain);
      gain.connect(ctx.destination);
    } catch (e) {}
  }, []);

  useEffect(() => {
    const savedRecord = localStorage.getItem("runnerSurtidorRecord");
    if (savedRecord) setRecord(parseInt(savedRecord, 10));
  }, []);

  const cargarRankingGlobal = useCallback(async () => {
    try {
      const token = localStorage.getItem("token");
      const API_URL = process.env.REACT_APP_API_URL;
      const response = await fetch(`${API_URL}/api/juego/ranking`, {
        method: "GET",
        headers: { "Content-Type": "application/json", ...(token && { Authorization: `Bearer ${token}` }) }
      });
      if (response.ok) {
        const data = await response.json();
        const rankingValido = Array.isArray(data) ? data.filter(d => d.juego === 'runner_surtidor') : [];
        setRankingBD(rankingValido);
        const miPuntajeDB = rankingValido.find(user => user.nombre === nombreUsuario);
        if (miPuntajeDB) {
          setMiRecordMaximo(miPuntajeDB.puntos || 0);
          setMisEstrellasMaximas(miPuntajeDB.estrellas || 0);
          if (miPuntajeDB.puntos > record) {
            setRecord(miPuntajeDB.puntos);
            localStorage.setItem("runnerSurtidorRecord", miPuntajeDB.puntos.toString());
          }
        }
      }
    } catch (error) {
      setRankingBD([{ nombre: nombreUsuario, centro: centroTrabajoUsuario, puntos: record, estrellas: 0 }]);
    }
  }, [nombreUsuario, centroTrabajoUsuario, record]);

  const guardarPuntajeEnBD = useCallback(async (puntosNuevos, estrellasTotales) => {
    try {
      const token = localStorage.getItem("token");
      const API_URL = process.env.REACT_APP_API_URL;
      await fetch(`${API_URL}/api/juego/guardar`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...(token && { Authorization: `Bearer ${token}` }) },
        body: JSON.stringify({ nombre: nombreUsuario, centro: centroTrabajoUsuario, puntos: puntosNuevos, estrellas: Math.max(estrellasTotales, misEstrellasMaximas), juego: "runner_surtidor" })
      });
      if (puntosNuevos > miRecordMaximo) setMiRecordMaximo(puntosNuevos);
      if (estrellasTotales > misEstrellasMaximas) setMisEstrellasMaximas(estrellasTotales);
      cargarRankingGlobal(); 
    } catch (error) {}
  }, [nombreUsuario, centroTrabajoUsuario, misEstrellasMaximas, miRecordMaximo, cargarRankingGlobal]);

  useEffect(() => {
    if (juegoAbierto) cargarRankingGlobal();
  }, [juegoAbierto, cargarRankingGlobal]);

  const perderJuego = useCallback(() => {
    reproducirSonido("choque");
    setGameOver(true);
    setJugando(false);
    setPausado(false);
    if (puntajeRef.current > record) {
      setRecord(puntajeRef.current);
      localStorage.setItem("runnerSurtidorRecord", puntajeRef.current.toString());
    }
    guardarPuntajeEnBD(puntajeRef.current, estrellasRef.current);
  }, [record, guardarPuntajeEnBD, reproducirSonido]);

  const actualizarFrame = useCallback((time) => {
    if (!lastTimeRef.current) lastTimeRef.current = time;
    const deltaTime = time - lastTimeRef.current;
    lastTimeRef.current = time;
    const dt = Math.min(deltaTime / 16.666, 3);

    if (jugando && !gameOver && !pausado) {
      const gravedad = (mascotaVy.current < 0 || !saltandoRef.current) ? 1.25 : 0.55;
      mascotaVy.current -= gravedad * dt; 
      mascotaY.current += mascotaVy.current * dt;

      const enSuelo = mascotaY.current <= 0;
      if (enSuelo) {
        mascotaY.current = 0;
        mascotaVy.current = 0;
        saltandoRef.current = false;
      }

      const factorDificultad = Math.min(puntajeRef.current / 250, 2.5);
      velocidadGlobal.current = 7.0 + factorDificultad;

      obstaculoX.current -= velocidadGlobal.current * dt;
      itemX.current -= velocidadGlobal.current * dt;
      if (estrellaActiva.current) estrellaX.current -= velocidadGlobal.current * dt;
      
      sueloX.current -= velocidadGlobal.current * 1.8 * dt; 
      fondoX.current -= velocidadGlobal.current * 0.4 * dt; 
      nubesX.current -= velocidadGlobal.current * 0.1 * dt; 

      if (obstaculoX.current < -100) {
        obstaculoX.current = 850 + Math.random() * 250;
        if (!primerObstaculoPasado.current) {
          esAereo.current = false;
          primerObstaculoPasado.current = true;
        } else {
          esAereo.current = Math.random() < 0.42; 
        }
        const listaObs = esAereo.current ? OBSTACULOS_AEREOS : OBSTACULOS_SUELO;
        if (obstaculoLabelRef.current) obstaculoLabelRef.current.innerText = listaObs[Math.floor(Math.random() * listaObs.length)];

        if (!estrellaActiva.current && estrellasRef.current < 3 && puntajeRef.current > 200 && Math.random() < 0.01) {
          estrellaActiva.current = true;
          estrellaX.current = obstaculoX.current + 450;
          estrellaY.current = 115;
        }
      }

      if (itemX.current < -100) {
        itemX.current = obstaculoX.current + 400 + Math.random() * 200;
        itemY.current = 45 + Math.random() * 110; 
        if (itemLabelRef.current) itemLabelRef.current.innerText = FRUTAS[Math.floor(Math.random() * FRUTAS.length)];
      }

      if (estrellaX.current < -100) estrellaActiva.current = false;

      const hitMascota = { left: MASCOTA_X + 20, right: MASCOTA_X + MASCOTA_SIZE - 20, bottom: mascotaY.current + 4, top: mascotaY.current + MASCOTA_SIZE - 12 };
      const baseObstaculoY = esAereo.current ? 95 : 0; 
      const altoObstaculoY = esAereo.current ? 135 : 32; 

      const hitObstaculo = { left: obstaculoX.current + 10, right: obstaculoX.current + OBSTACULO_SIZE - 10, bottom: baseObstaculoY, top: altoObstaculoY };
      const hitFruta = { left: itemX.current + 6, right: itemX.current + ITEM_SIZE - 6, bottom: itemY.current + 6, top: itemY.current + ITEM_SIZE - 6 };
      const hitEstrella = { left: estrellaX.current + 6, right: estrellaX.current + ESTRELLA_SIZE - 6, bottom: estrellaY.current + 6, top: estrellaY.current + ESTRELLA_SIZE - 6 };

      const chocaX = hitObstaculo.left < hitMascota.right && hitObstaculo.right > hitMascota.left;
      const chocaY = hitObstaculo.bottom < hitMascota.top && hitObstaculo.top > hitMascota.bottom;

      if (chocaX && chocaY) {
        if (mascotaRef.current) {
          mascotaRef.current.style.transform = `translateY(${-mascotaY.current}px) rotate(-90deg) scale(0.75)`;
          mascotaRef.current.style.filter = `sepia(1) hue-rotate(-50deg) saturate(6) drop-shadow(0 0 25px red)`;
        }
        perderJuego();
        return;
      }

      const recogeFrutaX = hitFruta.left < hitMascota.right && hitFruta.right > hitMascota.left;
      const recogeFrutaY = hitFruta.bottom < hitMascota.top && hitFruta.top > hitMascota.bottom;

      if (recogeFrutaX && recogeFrutaY) {
        reproducirSonido("fruta");
        frutasComidasRef.current += 1;
        if (frutasComidasRef.current % 3 === 0) {
          multRef.current = Math.min(multRef.current + 1, 6);
          setMultiplicadorVisual(multRef.current);
        }
        puntajeRef.current += 10 * multRef.current;
        setPuntuacion(puntajeRef.current);
        itemX.current = -200; 
        if (mascotaRef.current) {
          mascotaRef.current.style.filter = `brightness(1.8) drop-shadow(0 0 18px gold)`;
          setTimeout(() => { if(mascotaRef.current && !gameOver) mascotaRef.current.style.filter = "none"; }, 120);
        }
      }

      const recogeEstrellaX = estrellaActiva.current && hitEstrella.left < hitMascota.right && hitEstrella.right > hitMascota.left;
      const recogeEstrellaY = estrellaActiva.current && hitEstrella.bottom < hitMascota.top && hitEstrella.top > hitMascota.bottom;

      if (recogeEstrellaX && recogeEstrellaY) {
        if (estrellasRef.current < 3) {
          estrellasRef.current += 1;
          setEstrellasPartida(estrellasRef.current);
        }
        reproducirSonido("estrella");
        setFlashVisual(true);
        setTimeout(() => setFlashVisual(false), 300);

        multRef.current = Math.min(multRef.current + 2, 6);
        setMultiplicadorVisual(multRef.current);
        puntajeRef.current += 300; 
        setPuntuacion(puntajeRef.current);
        estrellaActiva.current = false;
        estrellaX.current = -400;
      }

      let targetRot = 0;
      let targetScaleX = 1;
      let targetScaleY = 1;

      if (!enSuelo) {
        if (mascotaVy.current > 0) { targetRot = -14; targetScaleY = 1.2; targetScaleX = 0.85; } 
        else { targetRot = 14; targetScaleY = 0.9; targetScaleX = 1.1; }
      } else {
        pasoAnim.current += 0.35 * dt;
        targetRot = Math.sin(pasoAnim.current) * 7; 
        targetScaleY = 1 + Math.abs(Math.sin(pasoAnim.current)) * 0.08; 
        targetScaleX = 1 - Math.abs(Math.sin(pasoAnim.current)) * 0.04;
      }

      renderScaleX.current += (targetScaleX - renderScaleX.current) * 0.25 * dt;
      renderScaleY.current += (targetScaleY - renderScaleY.current) * 0.25 * dt;
      renderRot.current += (targetRot - renderRot.current) * 0.25 * dt;

      if (mascotaRef.current) {
        mascotaRef.current.style.transform = `translateY(${-mascotaY.current}px) rotate(${renderRot.current}deg) scale(${renderScaleX.current}, ${renderScaleY.current})`;
        mascotaRef.current.style.filter = enSuelo ? "drop-shadow(0 6px 10px rgba(0,0,0,0.5))" : "drop-shadow(0 12px 18px rgba(0,0,0,0.35))";
      }
      
      if (obstaculoRef.current) {
        obstaculoRef.current.style.transform = `translateX(${obstaculoX.current}px)`;
        obstaculoRef.current.style.bottom = `${esAereo.current ? 95 : 42}px`;
      }
      
      if (itemRef.current) itemRef.current.style.transform = `translate(${itemX.current}px, ${-itemY.current}px)`;
      if (estrellaRef.current) {
        estrellaRef.current.style.transform = `translate(${estrellaX.current}px, ${-estrellaY.current}px)`;
        estrellaRef.current.style.display = estrellaActiva.current ? "flex" : "none";
      }

      if (sueloRef.current) sueloRef.current.style.backgroundPositionX = `${sueloX.current}px`;
      if (nubesRef.current) nubesRef.current.style.backgroundPositionX = `${nubesX.current}px`;
      if (fondoRef.current) fondoRef.current.style.backgroundPositionX = `${fondoX.current}px`;
    }

    requestRef.current = requestAnimationFrame(actualizarFrame);
  }, [jugando, gameOver, pausado, perderJuego, reproducirSonido]);

  useEffect(() => {
    if (jugando && !gameOver) {
      lastTimeRef.current = performance.now();
      requestRef.current = requestAnimationFrame(actualizarFrame);
    }
    return () => cancelAnimationFrame(requestRef.current);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jugando, gameOver]);

  const iniciarJuego = () => {
    setGameOver(false);
    setJugando(true);
    setPausado(false);
    setPuntuacion(0);
    
    puntajeRef.current = 0;
    multRef.current = 1;
    setMultiplicadorVisual(1);
    frutasComidasRef.current = 0;
    estrellasRef.current = misEstrellasMaximas; 
    setEstrellasPartida(misEstrellasMaximas);
    
    estrellaActiva.current = false;
    primerObstaculoPasado.current = false;
    esAereo.current = false;
    velocidadGlobal.current = 7.0;
    mascotaY.current = 0;
    mascotaVy.current = 16.0;
    saltandoRef.current = true;
    
    obstaculoX.current = 900;
    itemX.current = 1300;
    estrellaX.current = 2500;
    
    sueloX.current = 0;
    fondoX.current = 0;
    nubesX.current = 0;
    lastTimeRef.current = performance.now();
    
    if (mascotaRef.current) {
      mascotaRef.current.style.transition = "none";
      mascotaRef.current.style.filter = "none";
      mascotaRef.current.style.transform = `translateY(0px) rotate(0deg) scale(1, 1)`;
    }
  };

  const iniciarSalto = (e) => {
    if (jugando && e && e.target && e.target.closest && e.target.closest('button')) return;
    if (e && e.stopPropagation) e.stopPropagation();
    if (pausado) return;

    if (!jugando) {
      iniciarJuego();
    } else if (mascotaY.current <= 5) {
      reproducirSonido("salto");
      mascotaVy.current = 16.0;
      saltandoRef.current = true;
    }
  };

  const soltarSalto = () => { saltandoRef.current = false; };
  const reiniciar = (e) => { if (e && e.stopPropagation) e.stopPropagation(); iniciarJuego(); };

  const rankingDinámico = [
    ...rankingBD,
    { nombre: nombreUsuario, centro: centroTrabajoUsuario, puntos: Math.max(puntuacion, miRecordMaximo), estrellas: Math.max(estrellasRef.current, misEstrellasMaximas), esUsuario: true }
  ].reduce((acc, current) => {
    const x = acc.find(item => item.nombre === current.nombre);
    if (!x) return acc.concat([current]);
    x.puntos = Math.max(x.puntos, current.puntos);
    if (current.esUsuario) x.estrellas = Math.max(x.estrellas || 0, current.estrellas || 0);
    return acc;
  }, [])
  .sort((a, b) => b.puntos - a.puntos)
  .slice(0, 10); 

  const nivelActual = Math.floor(puntuacion / 120);
  const pasilloActivo = PASILLOS[nivelActual % PASILLOS.length];

  return (
    <>
      {!juegoAbierto && !alCerrar && (
        <button onClick={() => setJuegoAbierto(true)} className="fixed bottom-24 right-4 sm:right-6 z-[99999] group cursor-pointer transition-transform duration-300 hover:-translate-y-2">
          <div className="bg-emerald-600 hover:bg-emerald-700 text-white rounded-full p-3.5 sm:p-4 shadow-[0_10px_25px_rgba(16,185,129,0.4)] border-2 border-emerald-400 flex items-center gap-2.5 transition-all">
            <span className="text-xl sm:text-2xl animate-bounce">🏃‍♂️</span>
            <span className="font-extrabold text-sm sm:text-base hidden sm:block tracking-tight">¡Corre Surtidor!</span>
          </div>
        </button>
      )}

      {juegoAbierto &&
        ReactDOM.createPortal(
          <div className="fixed inset-0 z-[999999] bg-slate-950/85 flex items-center justify-center p-2 sm:p-6 animate-fade-in backdrop-blur-md">
            <div className="bg-slate-900 text-white rounded-[34px] shadow-[0_0_90px_rgba(16,185,129,0.3)] p-4 sm:p-7 border border-slate-700/80 w-full max-w-2xl relative transition-all mx-auto overflow-hidden">
              
              {flashVisual && <div className="absolute inset-0 bg-amber-400/40 z-50 pointer-events-none animate-pulse rounded-[34px]" />}

              <div className="absolute top-0 left-0 right-0 h-16 bg-slate-900/85 backdrop-blur-md z-30 border-b border-slate-800 px-5 flex items-center justify-between">
                 <div className="flex items-center gap-3">
                    <div className="w-9 h-9 bg-emerald-950 border border-emerald-700/60 rounded-xl flex items-center justify-center shadow-inner">
                      <img src={logoMascota} alt="Logo" className="w-6 h-6 object-contain" />
                    </div>
                    <div>
                        <h1 className="text-sm font-black text-emerald-400 tracking-wider">CORRE SURTIDOR</h1>
                        <p className="text-[9px] text-slate-400 uppercase tracking-widest font-bold truncate max-w-[150px] sm:max-w-xs">{centroTrabajoUsuario}</p>
                    </div>
                 </div>
                 
                 <button onClick={() => { setJuegoAbierto(false); if (alCerrar) alCerrar(); }} className="bg-slate-800 hover:bg-red-600 w-8 h-8 rounded-full font-extrabold text-slate-300 flex items-center justify-center cursor-pointer transition-colors">✕</button>
              </div>

              <div className="flex flex-col items-center w-full mt-12">
                
                <div className="w-full flex justify-between items-center my-3 px-1">
                  <div className="flex items-center gap-2.5">
                    <div className="bg-slate-800/90 border border-slate-700/80 px-3.5 py-1.5 rounded-2xl shadow-md text-slate-200">
                      <span className="text-[8px] font-black uppercase tracking-wider block text-emerald-400 leading-none">SECTOR</span>
                      <span className="text-xs font-bold leading-tight block truncate max-w-[110px]">{pasilloActivo.nombre}</span>
                    </div>
                    <div className="bg-slate-800/90 border border-slate-700/80 px-3.5 py-1.5 rounded-2xl shadow-md text-slate-200">
                      <span className="text-[8px] font-black uppercase tracking-wider block text-amber-400 leading-none">RÉCORD</span>
                      <span className="text-xs font-bold leading-tight block truncate">{Math.max(record, miRecordMaximo)} pts</span>
                    </div>
                  </div>

                  <div className="flex items-center gap-1 bg-amber-950/90 border border-amber-500/60 px-3.5 py-1.5 rounded-2xl shadow-[0_0_12px_rgba(251,191,36,0.2)]">
                      <span className="text-xs font-black text-amber-300 tracking-tight">⭐ {estrellasPartida} / 3</span>
                  </div>
                </div>

                {/* ESCENARIO DE JUEGO ESTILO 3D ARCADE */}
                <div 
                  onPointerDown={iniciarSalto}
                  onPointerUp={soltarSalto}
                  onPointerLeave={soltarSalto}
                  className={`w-full h-[300px] sm:h-[330px] rounded-[28px] relative overflow-hidden isolate cursor-pointer shadow-[inset_0_0_30px_rgba(0,0,0,0.6)] select-none border-2 border-slate-700/80 mx-auto transition-colors duration-1000 bg-gradient-to-b ${pasilloActivo.bg}`}
                >
                  
                  <div ref={fondoRef} className="absolute inset-0 z-0 opacity-30 mix-blend-overlay transition-colors duration-1000" style={{ backgroundImage: pasilloActivo.patronFondo, backgroundSize: "50px 50px", willChange: "background-position" }} />
                  <div ref={nubesRef} className="absolute inset-0 z-0 opacity-25 pointer-events-none" style={{ backgroundImage: "radial-gradient(ellipse at center, rgba(255,255,255,0.6) 0%, transparent 70%)", backgroundSize: "150px 80px", backgroundRepeat: "repeat-x", willChange: "background-position" }} />
                  <div className="absolute top-1/2 w-full text-center z-10 pointer-events-none transform -translate-y-1/2"><span className="text-white/10 text-8xl sm:text-9xl font-black tracking-tighter">{puntuacion}</span></div>

                  {jugando && multiplicadorVisual > 1 && (
                    <div className="absolute top-3 left-3 z-30 pointer-events-none bg-amber-950/90 border border-amber-500/60 px-3 py-1 rounded-full shadow-lg flex items-center gap-1 animate-pulse">
                      <span className="text-amber-300 font-black text-xs">🔥 x{multiplicadorVisual}</span>
                    </div>
                  )}

                  {/* SUELO CON EFECTO DE PROFUNDIDAD */}
                  <div ref={sueloRef} className={`absolute bottom-0 w-full h-[48px] border-t-4 z-10 shadow-[0_-10px_20px_rgba(0,0,0,0.5)] transition-colors duration-1000 ${pasilloActivo.piso} ${pasilloActivo.borde}`} style={{ backgroundImage: "repeating-linear-gradient(90deg, rgba(255,255,255,0.15) 0px, rgba(255,255,255,0.15) 25px, transparent 25px, transparent 50px)", willChange: "background-position" }} />

                  {/* MASCOTA CON AURA 3D */}
                  <div ref={mascotaRef} className="absolute z-20 flex items-center justify-center pointer-events-none origin-bottom" style={{ bottom: "45px", left: `${MASCOTA_X}px`, width: `${MASCOTA_SIZE}px`, height: `${MASCOTA_SIZE}px`, willChange: "transform, filter" }}>
                    <div className="absolute inset-0 bg-emerald-400/30 rounded-full filter blur-lg animate-pulse -z-10" />
                    <img src={logoMascota} alt="Mascota" className="w-full h-full object-contain filter drop-shadow-[0_10px_10px_rgba(0,0,0,0.5)]" />
                  </div>

                  <div ref={obstaculoRef} className={`absolute z-20 flex items-center justify-center pointer-events-none text-3xl drop-shadow-[0_8px_8px_rgba(0,0,0,0.6)] ${gameOver ? 'opacity-50' : 'opacity-100'}`} style={{ bottom: "42px", left: "0px", width: `${OBSTACULO_SIZE}px`, height: `${OBSTACULO_SIZE}px`, willChange: "transform, bottom" }} >
                    <span ref={obstaculoLabelRef}>🛒</span>
                    {esAereo.current && <div className="absolute inset-0 bg-red-500/30 rounded-full animate-pulse blur-md" />}
                  </div>

                  <div ref={itemRef} className="absolute z-25 flex items-center justify-center pointer-events-none text-2xl drop-shadow-[0_8px_8px_rgba(0,0,0,0.5)]" style={{ bottom: "45px", left: "0px", width: `${ITEM_SIZE}px`, height: `${ITEM_SIZE}px`, willChange: "transform" }}>
                    <span ref={itemLabelRef}>🍎</span>
                  </div>

                  <div ref={estrellaRef} className="absolute z-30 flex items-center justify-center pointer-events-none text-2xl animate-spin drop-shadow-[0_0_15px_gold] ring-2 ring-amber-400 rounded-full shadow-inner" style={{ bottom: "45px", left: "0px", width: `${ESTRELLA_SIZE}px`, height: `${ESTRELLA_SIZE}px`, willChange: "transform, display" }}>
                    <span>⭐</span>
                  </div>
                  
                  {!jugando && !gameOver && !pausado && (
                    <div className="absolute inset-0 bg-slate-950/80 backdrop-blur-sm flex flex-col items-center justify-center z-40 pointer-events-none p-4">
                      <div className="bg-slate-900/95 backdrop-blur-2xl p-6 rounded-[28px] text-center shadow-2xl border border-slate-700 max-w-[280px]">
                        <div className="w-14 h-14 mx-auto mb-3 bg-emerald-950 border border-emerald-800 rounded-2xl flex items-center justify-center shadow-inner">
                            <img src={logoMascota} alt="Logo" className="w-8 h-8 object-contain animate-bounce" />
                        </div>
                        <p className="text-white font-black text-base mb-1 tracking-tight">¡Corre Surtidor!</p>
                        <p className="text-slate-400 text-[11px] mb-5 font-medium leading-relaxed">Esquiva obstáculos terrestres y aéreos. ¡Recoge estrellas y frutas!</p>
                        <button onPointerDown={iniciarSalto} className="bg-emerald-600 hover:bg-emerald-500 text-white font-black py-3.5 w-full rounded-xl shadow-lg text-xs pointer-events-auto transition-all transform active:scale-95 border border-emerald-500 cursor-pointer uppercase tracking-widest">
                            INICIAR CARRERA
                        </button>
                      </div>
                    </div>
                  )}

                  {pausado && (
                    <div className="absolute inset-0 bg-slate-950/85 backdrop-blur-md flex flex-col items-center justify-center z-50 animate-fade-in pointer-events-auto p-4">
                      <div className="bg-slate-900 p-6 rounded-[28px] text-center shadow-2xl border border-slate-700 max-w-[260px]">
                        <span className="text-3xl block mb-2">⏸️</span>
                        <p className="text-white font-black text-lg mb-4 tracking-tight">JUEGO EN PAUSA</p>
                        <div className="flex flex-col gap-2.5">
                            <button onPointerDown={(e) => { e.stopPropagation(); setPausado(false); }} className="bg-emerald-600 hover:bg-emerald-500 text-white font-extrabold py-3 w-full rounded-xl shadow-md text-xs transition-all active:scale-95 cursor-pointer border border-emerald-500 uppercase tracking-wider">REANUDAR</button>
                            <button onPointerDown={(e) => { e.stopPropagation(); setPausado(false); setJugando(false); }} className="bg-slate-800 hover:bg-slate-700 text-slate-300 font-extrabold py-3 w-full rounded-xl text-xs transition-all active:scale-95 cursor-pointer border border-slate-700 uppercase tracking-wider">SALIR</button>
                        </div>
                      </div>
                    </div>
                  )}

                  {gameOver && (
                    <div className="absolute inset-0 bg-red-950/85 backdrop-blur-md flex flex-col items-center justify-center z-40 pointer-events-none p-4">
                      <div className="bg-slate-900 p-6 rounded-[28px] text-center shadow-2xl border border-red-900/50 max-w-[280px] animate-fade-in">
                        <span className="text-4xl block mb-1">💥</span>
                        <p className="text-red-500 font-black text-xl mb-1 tracking-tight">¡TROPIEZO!</p>
                        
                        <div className="bg-slate-950/90 p-3 rounded-2xl border border-red-900/40 mb-4 shadow-inner">
                            <p className="text-slate-400 text-[9px] uppercase tracking-widest font-extrabold mb-0.5">Puntaje Final</p>
                            <p className="font-black text-white text-3xl animate-pulse">{puntuacion}</p>
                        </div>

                        <button onPointerDown={reiniciar} className="bg-emerald-600 hover:bg-emerald-500 text-white font-black py-3.5 w-full rounded-xl shadow-lg pointer-events-auto active:scale-95 transition-all text-xs cursor-pointer border border-emerald-500 uppercase tracking-wider">CORRER DE NUEVO</button>
                      </div>
                    </div>
                  )}
                </div>

                {jugando && !gameOver && (
                    <button 
                        onPointerDown={(e) => { e.stopPropagation(); setPausado(true); }}
                        className="absolute bottom-16 right-3 sm:right-6 w-9 h-9 bg-slate-800/90 hover:bg-slate-700 border border-slate-600 rounded-full shadow-lg flex items-center justify-center text-slate-200 text-xs transition-transform active:scale-90 cursor-pointer z-30"
                    >⏸️</button>
                )}

                {!jugando && !pausado && (
                  <div className="w-full mt-3 bg-slate-950/60 rounded-[24px] p-3.5 shadow-xl border border-slate-800 backdrop-blur-sm">
                    <h4 className="text-[10px] font-black text-emerald-400 uppercase tracking-widest mb-2.5 flex items-center gap-2 justify-center pb-1.5 border-b border-slate-800/80">
                        <span>🏆</span> TOP 10 RUNNERS & ESTRELLAS
                    </h4>
                    <div className="flex flex-col gap-1.5 max-h-[130px] overflow-y-auto custom-scrollbar pr-1">
                      {rankingDinámico.length === 0 ? (
                        <p className="text-center text-xs text-slate-400 mt-2 font-medium">Aún no hay récords registrados.</p>
                      ) : (
                        rankingDinámico.map((item, index) => {
                          const esTop1 = index === 0;
                          const totalEstrellas = item.estrellas || 0;
                          let estiloAura = "border-slate-800 bg-slate-900/50";
                          let textoEstrellasBadge = "⭐ 0/3";
                          
                          if (totalEstrellas === 1) { estiloAura = "border-blue-500/40 bg-blue-950/20"; textoEstrellasBadge = "⭐ 1/3"; }
                          else if (totalEstrellas === 2) { estiloAura = "border-purple-500/40 bg-purple-950/20"; textoEstrellasBadge = "⭐ 2/3"; }
                          else if (totalEstrellas >= 3) { estiloAura = "border-amber-400/80 bg-amber-950/30 ring-1 ring-amber-400/40 font-black"; textoEstrellasBadge = "⭐ 3/3"; }

                          return (
                            <div key={index} className={`rounded-xl p-2 flex items-center justify-between border transition-all ${item.esUsuario ? 'bg-emerald-950/40 border-emerald-600/60' : estiloAura}`}>
                              <div className="flex items-center gap-2 flex-1 overflow-hidden pr-2">
                                <span className={`text-[10px] font-black w-5 h-5 shrink-0 rounded-full flex items-center justify-center ${esTop1 ? 'bg-amber-400 text-amber-950' : 'bg-slate-800 text-slate-300'}`}>
                                  {esTop1 ? '👑' : index + 1}
                                </span>
                                <div className="flex-1 min-w-0 pr-1">
                                  <p className="text-xs font-bold text-slate-200 truncate">{item.nombre}</p>
                                  <p className="text-[8px] text-slate-400 truncate tracking-wide -mt-0.5">{item.centro}</p>
                                </div>
                              </div>
                              <div className="flex items-center gap-2.5 shrink-0">
                                <span className={`text-[10px] font-bold ${totalEstrellas >= 3 ? 'text-amber-300' : 'text-slate-400'}`}>{textoEstrellasBadge}</span>
                                <span className={`text-[11px] font-extrabold px-2 py-0.5 rounded-lg ${esTop1 ? 'text-amber-950 bg-amber-400' : 'text-emerald-300 bg-emerald-950/80'}`}>{item.puntos} pts</span>
                              </div>
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
}